/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PatchedRegionRequest
 */
export interface PatchedRegionRequest {
  /**
   *
   * @type {string}
   * @memberof PatchedRegionRequest
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof PatchedRegionRequest
   */
  subdomain?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedRegionRequest
   */
  isEnabled?: boolean
  /**
   *
   * @type {string}
   * @memberof PatchedRegionRequest
   */
  province?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedRegionRequest
   */
  declination?: string | null
  /**
   *
   * @type {Array<string>}
   * @memberof PatchedRegionRequest
   */
  cityList?: Array<string>
}

/**
 * Check if a given object implements the PatchedRegionRequest interface.
 */
export function instanceOfPatchedRegionRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function PatchedRegionRequestFromJSON(json: any): PatchedRegionRequest {
  return PatchedRegionRequestFromJSONTyped(json, false)
}

export function PatchedRegionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedRegionRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
    subdomain: !exists(json, 'subdomain') ? undefined : json['subdomain'],
    isEnabled: !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
    province: !exists(json, 'province') ? undefined : json['province'],
    declination: !exists(json, 'declination') ? undefined : json['declination'],
    cityList: !exists(json, 'cityList') ? undefined : json['cityList'],
  }
}

export function PatchedRegionRequestToJSON(value?: PatchedRegionRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    subdomain: value.subdomain,
    isEnabled: value.isEnabled,
    province: value.province,
    declination: value.declination,
    cityList: value.cityList,
  }
}
